import React from 'react';
import {connect} from 'react-redux';

import {Typography} from '@mui/material';

import makeStyles from '@mui/styles/makeStyles';

import {deleteResource} from 'spectra-logic-ui/actions';
import {Color} from 'spectra-logic-ui/colors';
import {FormDialog} from 'spectra-logic-ui/components';
import {Dispatch} from 'spectra-logic-ui';

import {Object} from '@/buckets/objects/types';

type Props = {
  id: string;
  name: string;
  bucketName: string;
  object: Object;
  disabled?: boolean;
  onClose?: () => any;
  onSubmit: (values: any) => Promise<any>;
}

const useStyles = makeStyles({
  description: {
    color: Color.ERROR,
  },
});

const DeleteStorageDialog = ({disabled = false, onClose, onSubmit, ...others}: Props) => {
  const classes = useStyles();

  if (disabled) {
    return null;
  }
  return (
    <FormDialog
      title={'Remove Storage'} submitLabel='Delete' disableSubmit={disabled} onClose={onClose}
      onSubmit={onSubmit} closeOnSuccess {...others}
    >
      {() => (
        <Typography className={classes.description}>
          Are you sure you want to remove {others.name} ({others.id}) from this object?
        </Typography>
      )}
    </FormDialog>
  );
};

const mapDispatchToProps = (dispatch: Dispatch, {id, bucketName, object}: Props) => {
  const resource = `buckets/${bucketName}/storage/objects/${id}`;
  const query = {
    version: object.versionId !== undefined ? object.versionId : '',
  };
  return {
    onSubmit: (values: any) => dispatch(deleteResource(resource, object.key, values, {query: query})),
  };
};

export default connect(undefined, mapDispatchToProps)(DeleteStorageDialog);
